import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Button from "../components/ui/button";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { registerUser } from "../redux/authSlice";

export default function Register() {
  const dispatch = useDispatch();
  const [accountType, setAccountType] = useState("personal");

  
const getInitialValues = () => {
  return accountType === "business"
    ? {
        businessName: "",
        contactPerson: "",
        email: "",
        password: "",
        accountType: "business",
      }
    : {
        fullName: "",
        email: "",
        password: "",
        accountType: "personal",
      };
};

  const navigate = useNavigate();
  const personalSchema = Yup.object().shape({
    fullName: Yup.string().required("Full name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string().min(6, "Too short").required("Password is required"),
  });

  const businessSchema = Yup.object().shape({
    businessName: Yup.string().required("Business name is required"),
    contactPerson: Yup.string().required("Contact person is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string().min(6, "Too short").required("Password is required"),
  });

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#3490dc] to-[#6574cd] p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-3xl font-bold text-center text-[#3490dc] mb-6">
          Create Your Questa Account
        </h2>

        <div className="flex justify-center gap-4 mb-6">
          <button
            type="button"
            onClick={() => setAccountType("personal")}
            className={`px-4 py-2 rounded-full border transition text-sm font-medium ${
              accountType === "personal"
                ? "bg-[#3490dc] text-white"
                : "bg-gray-100 text-gray-700"
            }`}
          >
            Personal
          </button>
          <button
            type="button"
            onClick={() => setAccountType("business")}
            className={`px-4 py-2 rounded-full border transition text-sm font-medium ${
              accountType === "business"
                ? "bg-[#3490dc] text-white"
                : "bg-gray-100 text-gray-700"
            }`}
          >
            Business
          </button>
        </div>

        <Formik
          initialValues={getInitialValues()}
          enableReinitialize
          validationSchema={
            accountType === "personal" ? personalSchema : businessSchema
          }
          onSubmit={async (values, {resetForm}) => {
            const {businessName, fullName, contactPerson, email, password, accountType} = values;

            let payload = {};

            if (accountType === "personal") {
              payload = {
                fullName,
                email,
                password,
                accountType,
              };
            } else {
              payload = {
                businessName,
                name: contactPerson, // assuming backend expects `name`
                email,
                password,
                accountType,
              };
            }

            try{
              dispatch(registerUser(payload)).unwrap().then((res) => {
                toast.success("Welcome to Questa, Your survey goat");
                navigate("/login")
              })
            }catch(err){
              console.log(err)
            }
          }}
        >
          {({ touched, errors }) => (
            <Form className="space-y-4">
              {accountType === "personal" ? (
                <div>
                  <label className="block font-medium text-sm text-gray-700 mb-1">
                    Full Name
                  </label>
                  <Field
                    name="fullName"
                    className={`w-full px-4 py-2 rounded-lg border ${
                      errors.fullName && touched.fullName
                        ? "border-red-500"
                        : "border-gray-300"
                    } focus:outline-none focus:ring-2 focus:ring-[#3490dc]`}
                  />
                  <ErrorMessage
                    name="fullName"
                    component="div"
                    className="text-red-500 text-xs mt-1"
                  />
                </div>
              ) : (
                <>
                  <div>
                    <label className="block font-medium text-sm text-gray-700 mb-1">
                      Business Name
                    </label>
                    <Field
                      name="businessName"
                      className={`w-full px-4 py-2 rounded-lg border ${
                        errors.businessName && touched.businessName
                          ? "border-red-500"
                          : "border-gray-300"
                      } focus:outline-none focus:ring-2 focus:ring-[#3490dc]`}
                    />
                    <ErrorMessage
                      name="businessName"
                      component="div"
                      className="text-red-500 text-xs mt-1"
                    />
                  </div>
                  <div>
                    <label className="block font-medium text-sm text-gray-700 mb-1">
                      Contact Person
                    </label>
                    <Field
                      name="contactPerson"
                      className={`w-full px-4 py-2 rounded-lg border ${
                        errors.contactPerson && touched.contactPerson
                          ? "border-red-500"
                          : "border-gray-300"
                      } focus:outline-none focus:ring-2 focus:ring-[#3490dc]`}
                    />
                    <ErrorMessage
                      name="contactPerson"
                      component="div"
                      className="text-red-500 text-xs mt-1"
                    />
                  </div>
                </>
              )}

              <div>
                <label className="block font-medium text-sm text-gray-700 mb-1">
                  Email
                </label>
                <Field
                  name="email"
                  type="email"
                  className={`w-full px-4 py-2 rounded-lg border ${
                    errors.email && touched.email
                      ? "border-red-500"
                      : "border-gray-300"
                  } focus:outline-none focus:ring-2 focus:ring-[#3490dc]`}
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-red-500 text-xs mt-1"
                />
              </div>

              <div>
                <label className="block font-medium text-sm text-gray-700 mb-1">
                  Password
                </label>
                <Field
                  name="password"
                  type="password"
                  className={`w-full px-4 py-2 rounded-lg border ${
                    errors.password && touched.password
                      ? "border-red-500"
                      : "border-gray-300"
                  } focus:outline-none focus:ring-2 focus:ring-[#3490dc]`}
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="text-red-500 text-xs mt-1"
                />
              </div>

              <Button type="submit" className="w-full mt-4">
                Register
              </Button>
            </Form>
          )}
        </Formik>
        <div className="mt-4 text-center text-sm text-gray-600">
            Already have an account?{" "}
            <Link
              to="/login"
              className="text-[#3490dc] font-medium hover:underline"
            >
              Return to Login
            </Link>
          </div>
      </div>
    </div>
  );
}
